<template>
  <div
    v-if="wikiItem?.has_multiple_links"
    v-bind="$attrs"
    class="flex items-start gap-1.5 rounded bg-amber-50 px-2 py-1 text-xs font-medium whitespace-normal text-amber-800"
  >
    <FontAwesomeIcon class="mt-0.5" :icon="['fas', 'triangle-exclamation']" />
    <span>{{ message }}</span>
  </div>
</template>

<script>
export default {
  name: 'WikiItemMultipleLinksWarning',
  inheritAttrs: false,
  props: {
    wikiItem: {
      type: Object,
      default: null
    }
  },
  computed: {
    message() {
      const count = this.wikiItem.linked_items_count
      const names = (this.wikiItem.linked_items ?? [])
        .map((item) => this.$trans(item.name))
        .join(', ')

      return names
        ? this.$t('global.wiki_item_multiple_links_with_names', {
            count,
            names
          })
        : this.$t('global.wiki_item_multiple_links', { count })
    }
  }
}
</script>
